class Evaluation {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event(){
		const $links = $('.c-nav-menu .list-wrap a[href^="#"]');
		const pcQuery = window.matchMedia('(min-width: 768px)');
		const spQuery = window.matchMedia('(max-width: 767px)');
		const offset = 120; // ヘッダー分・見出し位置の調整
	
		const targets = [];
	
		$links.each(function () {
			const $link = $(this);
			const id = $link.attr('href');
			const $target = $(id);
	
			if ($target.length) {
				targets.push({
					link: $link,
					target: $target
				});
			}
		});
	
		function clearActive() {
			$links.removeClass('is-active');
		}
	
		function setActive() {
			if (!pcQuery.matches) {
				clearActive();
				return;
			}
	
			const scrollTop = $(window).scrollTop();
			let current = targets[0];
	
			$.each(targets, function (_, item) {
				const targetTop = item.target.offset().top;
	
				if (scrollTop + offset >= targetTop) {
					current = item;
				}
			});
	
			clearActive();
	
			if (current) {
				current.link.addClass('is-active');
			}
		}
	
		$(window).on('scroll resize', setActive);
		setActive();
	
		$links.on('click', function () {
			if (!pcQuery.matches) return;
	
			clearActive();
			$(this).addClass('is-active');
		});

		if (spQuery.matches) {
			$(function(){
				$('.c-nav-menu').click(function(){  //←囲んでる要素
					$(this).find('.list-wrap').slideToggle();  //←開閉したい要素
					$(this).toggleClass('is-open');  //←囲んでる要素にis-openクラスを切り替え
				});
			});
		}
	}
}

class SingleInterview {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  initLoopAutoSwiper({
    swiperSelector,
    prevSelector,
    nextSelector,
    currentSelector,
    totalSelector,
    spaceBetween,
    spaceBetweenMobile,
  }) {
    const swiperEl = document.querySelector(swiperSelector);
    if (!swiperEl) return null;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return null;

    const originalSlides = Array.from(
      wrapper.querySelectorAll(':scope > .swiper-slide')
    );
    const originalCount = originalSlides.length;
    if (originalCount === 0) return null;

    const containerW = swiperEl.getBoundingClientRect().width;
    const slideW = originalSlides[0]
      ? originalSlides[0].getBoundingClientRect().width
      : 0;

    const gapForLoop =
      spaceBetweenMobile != null
        ? Math.min(spaceBetween, spaceBetweenMobile)
        : spaceBetween;

    const approxVisible =
      slideW > 0 && containerW > 0
        ? (containerW + gapForLoop) / (slideW + gapForLoop)
        : 2;

    const minLoopSlides = Math.max(
      10,
      Math.ceil(approxVisible) * 2 + 6,
      originalCount * 3
    );

    let cloneCursor = 0;
    while (wrapper.querySelectorAll('.swiper-slide').length < minLoopSlides) {
      const src = originalSlides[cloneCursor % originalCount];
      const clone = src.cloneNode(true);
      clone.classList.add(`${swiperSelector.replace(/^\./, '')}-clone`);
      wrapper.appendChild(clone);
      cloneCursor += 1;
    }

    const swiperOptions = {
      loop: true,
      loopAdditionalSlides: originalCount,
      slidesPerView: 'auto',
      spaceBetween,
      centeredSlides: true,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      speed: 500,
      watchSlidesProgress: true,
      roundLengths: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextSelector,
        prevEl: prevSelector,
      },
    };

    if (spaceBetweenMobile != null) {
      swiperOptions.spaceBetween = spaceBetweenMobile;
      swiperOptions.breakpoints = {
        768: {
          spaceBetween,
        },
      };
    }

    const instance = new Swiper(swiperSelector, swiperOptions);

    const currentEl = document.querySelector(`${currentSelector} .current`);
    const totalEl = document.querySelector(`${totalSelector} .total`);
    const formatNumber = (num) => String(num).padStart(2, '0');

    const updatePagination = () => {
      const idx =
        ((instance.realIndex % originalCount) + originalCount) % originalCount;
      if (currentEl) currentEl.textContent = formatNumber(idx + 1);
      if (totalEl) totalEl.textContent = formatNumber(originalCount);
    };

    updatePagination();
    instance.on('slideChange', updatePagination);

    return instance;
  }

  event() {
    this.initLoopAutoSwiper({
      swiperSelector: '.work-swiper',
      prevSelector: '.work-swiper-button-prev',
      nextSelector: '.work-swiper-button-next',
      currentSelector: '.work-swiper-pagination',
      totalSelector: '.work-swiper-pagination',
      spaceBetween: 40,
    });

    this.initLoopAutoSwiper({
      swiperSelector: '.others-swiper',
      prevSelector: '.others-swiper-button-prev',
      nextSelector: '.others-swiper-button-next',
      currentSelector: '.others-swiper-pagination',
      totalSelector: '.others-swiper-pagination',
      spaceBetween: 30,
      spaceBetweenMobile: 15,
    });
  }
}

class SingleNews {
  constructor(el) {
    this.el = el;

    if (!document.querySelector('.' + this.el)) {
      return;
    }

    this.initScrollHint();
  }

  initScrollHint() {
    const scrollables = document.querySelectorAll('.' + this.el + ' .js-news-table-scroll');

    if (!scrollables.length || typeof ScrollHint === 'undefined') {
      return;
    }

    const mq = window.matchMedia('(max-width: 767px)');

    if (!mq.matches) {
      return;
    }

    if (this.scrollHintInited) {
      return;
    }

    this.scrollHintInited = true;

    new ScrollHint('.' + this.el + ' .js-news-table-scroll', {
      suggestiveShadow: true,
      scrollHintIconAppendClass: 'scroll-hint-icon-white',
      i18n: {
        scrollable: 'スクロールできます',
      },
    });
  }
}

class SingleRecruit {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.initFloatMenu();
    }
  }

  initFloatMenu() {
    const floatMenu = document.querySelector('.js-recruit-float-menu');
    const footer = document.querySelector('.js-footer');
    if (!floatMenu) return;

    const scrollThreshold = 500;
    let ticking = false;

    const update = () => {
      const footerReached = footer
        ? footer.getBoundingClientRect().top <= window.innerHeight
        : false;
      const isVisible = window.scrollY >= scrollThreshold && !footerReached;

      floatMenu.classList.toggle('is-visible', isVisible);
      floatMenu.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }
}

class SingleWorks {
  constructor(el, opt) {
    this.rootSelectors = (Array.isArray(el) ? el : [el]).map((name) => `.${name}`);
    const hasTargetPage = this.rootSelectors.some((selector) => document.querySelector(selector));

    if (hasTargetPage) {
      this.initFloatCta();
      this.event();
    }
  }

  initFloatCta() {
    const floatCta = document.querySelector('.js-works-float-cta');
    const footer = document.querySelector('.js-footer');
    if (!floatCta) return;

    let ticking = false;

    const update = () => {
      const footerReached = footer
        ? footer.getBoundingClientRect().top <= window.innerHeight
        : false;
      floatCta.classList.toggle('is-hidden', footerReached);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  event() {
    const findWithinRoots = (selector) => (
      this.rootSelectors.flatMap((rootSelector) => (
        Array.from(document.querySelectorAll(`${rootSelector} ${selector}`))
      ))
    );

    const createSlider = ({
      wrapper,
      swiper,
      name,
      spaceBetween = 0,
      slidesPerView = 'auto',
      breakpoints = null,
      withControls = true,
      loop = null,
    }) => {
      const wrapperEls = findWithinRoots(wrapper);
      if (wrapperEls.length < 1) return [];

      return Array.from(wrapperEls).map((wrapperEl) => {
        const swiperEl = wrapperEl.querySelector(swiper);
        if (!swiperEl) return null;

        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        const swiperOptions = {
          loop: loop !== null ? loop : slideCount > 2,
          slidesPerView,
          spaceBetween,
          speed: 500,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        };

        if (breakpoints) {
          swiperOptions.breakpoints = breakpoints;
        }

        if (withControls) {
          swiperOptions.pagination = {
            el: wrapperEl.querySelector(`.${name}-swiper-pagination`),
            type: 'fraction',
            formatFractionCurrent: (number) => String(number).padStart(2, '0'),
            formatFractionTotal: (number) => String(number).padStart(2, '0'),
          };
          swiperOptions.navigation = {
            nextEl: wrapperEl.querySelector(`.${name}-swiper-button-next`),
            prevEl: wrapperEl.querySelector(`.${name}-swiper-button-prev`),
          };
        }

        const instance = new Swiper(swiperEl, swiperOptions);

        instance.autoplay.stop();
        return { wrapperEl, instance };
      }).filter(Boolean);
    };

    const sliders = [
      ...createSlider({
        wrapper: '.js-works-career-swiper-wrapper',
        swiper: '.js-works-career-swiper',
        name: 'works-career',
        spaceBetween: 8,
      }),
      ...createSlider({
        wrapper: '.js-works-interview-swiper-wrapper',
        swiper: '.js-works-interview-swiper',
        name: 'works-interview',
        spaceBetween: 0,
      }),
      ...createSlider({
        wrapper: '.js-recruit-gallery-swiper-wrapper',
        swiper: '.js-recruit-gallery-swiper',
        name: 'recruit-gallery',
        spaceBetween: 8,
        withControls: false,
        loop: false,
        breakpoints: {
          768: {
            spaceBetween: 33,
          },
        },
      }),
    ];

    if (sliders.length < 1) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const target = sliders.find((item) => entry.target === item.wrapperEl);
        if (!target) return;
        if (entry.isIntersecting) {
          target.instance.autoplay.start();
        } else {
          target.instance.autoplay.stop();
        }
      });
    }, { threshold: 0.1 });

    sliders.forEach((item) => observer.observe(item.wrapperEl));
  }
}

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.initScrollRestore();
      this.event();
    }
  }
  initScrollRestore() {
    const storageKey = 'lifefund_top_scroll_y';
    const spMedia = window.matchMedia('(max-width: 767px)');

    window.addEventListener('pagehide', () => {
      sessionStorage.setItem(storageKey, String(window.scrollY));
    });

    if (!spMedia.matches) return;

    const nav = performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'reload') return;

    const saved = sessionStorage.getItem(storageKey);
    if (!saved) return;

    const y = parseInt(saved, 10);
    if (y <= 0) return;

    const restore = () => {
      window.scrollTo(0, y);
    };

    restore();
    requestAnimationFrame(restore);
    window.addEventListener('load', restore, { once: true });

    const video = document.querySelector('.js-hero-video');
    if (video) {
      video.addEventListener('loadeddata', restore, { once: true });
    }
  }
  initHeroVideo() {
    const video = document.querySelector('.js-hero-video');
    if (!video) return;

    const isSp = window.matchMedia('(max-width: 767px)').matches;
    const src = isSp ? video.dataset.srcSp : video.dataset.srcPc;
    if (!src) return;

    video.src = src;
    video.load();
    const playPromise = video.play({ preventScroll: true });
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        video.play().catch(() => {});
      });
    }
  }
  initHeaderLogoOnMvScroll() {
    const mv = document.querySelector('.js-top-mv');
    const logoLink = document.querySelector('.js-header-logo');
    if (!mv || !logoLink) return;

    const spMedia = window.matchMedia('(max-width: 767px)');
    let ticking = false;

    const update = () => {
      if (!spMedia.matches) {
        logoLink.classList.remove('is-past-mv');
        ticking = false;
        return;
      }

      const pastMv = mv.getBoundingClientRect().bottom <= 0;
      logoLink.classList.toggle('is-past-mv', pastMv);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }
  event(){
    this.initHeroVideo();
    this.initHeaderLogoOnMvScroll();

    const movieSwiperEl = document.querySelector('.js-movie-swiper');
    const movieSlideCount = movieSwiperEl ? movieSwiperEl.querySelectorAll('.swiper-slide').length : 0;
    const shouldLoopMovieSwiper = movieSlideCount > 3;
    const movieControls = document.querySelector('.js-movie-swiper-wrapper .js-movie-swiper-controls');
    const movieDesktopMedia = window.matchMedia('(min-width: 768px)');
    const updateMovieControlsVisibility = () => {
      if (!movieControls || movieSlideCount > 3) return;
      movieControls.style.display = movieDesktopMedia.matches ? 'none' : '';
    };

    updateMovieControlsVisibility();
    if (movieDesktopMedia.addEventListener) {
      movieDesktopMedia.addEventListener('change', updateMovieControlsVisibility);
    } else if (movieDesktopMedia.addListener) {
      movieDesktopMedia.addListener(updateMovieControlsVisibility);
    }

    const movieSwiper = new Swiper('.js-movie-swiper', {
      loop: shouldLoopMovieSwiper,
      rewind: !shouldLoopMovieSwiper,
      initialSlide: 0,
      slidesPerView: 1.25,
      centeredSlides: true,
      spaceBetween: 0,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      // スマホ時に表示スライド数を1.3（中央寄せ）に切り替えるブレークポイント設定
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
      pagination: {
        el: '.js-movie-swiper-wrapper .movie-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: (number) => String(number).padStart(2, '0'),
        formatFractionTotal: (number) => String(number).padStart(2, '0'),
      },
      navigation: {
        nextEl: '.js-movie-swiper-wrapper .movie-swiper-button-next',
        prevEl: '.js-movie-swiper-wrapper .movie-swiper-button-prev',
      },
    });
    movieSwiper.autoplay.stop();

    const jobSwiper = new Swiper('.js-job-swiper', {
      loop: true,
      slidesPerView: 1.6,
      spaceBetween: 8,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      // スマホ時に表示スライド数を1.3（中央寄せ）に切り替えるブレークポイント設定
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 16,
        },
      },
      pagination: {
        el: '.js-job-swiper-wrapper .job-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: (number) => String(number).padStart(2, '0'),
        formatFractionTotal: (number) => String(number).padStart(2, '0'),
      },
      navigation: {
        nextEl: '.js-job-swiper-wrapper .job-swiper-button-next',
        prevEl: '.js-job-swiper-wrapper .job-swiper-button-prev',
      },
    });
    jobSwiper.autoplay.stop();

    const interviewSwiper = new Swiper('.js-interview-swiper', {
      loop: true,
      slidesPerView: 1.2,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      // スマホ時に表示スライド数を1.3（中央寄せ）に切り替えるブレークポイント設定
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          centeredSlides: true,
        },
      },
      pagination: {
        el: '.js-interview-swiper-wrapper .interview-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: (number) => String(number).padStart(2, '0'),
        formatFractionTotal: (number) => String(number).padStart(2, '0'),
      },
      navigation: {
        nextEl: '.js-interview-swiper-wrapper .interview-swiper-button-next',
        prevEl: '.js-interview-swiper-wrapper .interview-swiper-button-prev',
      },
    });
    interviewSwiper.autoplay.stop();

    const swiperObserverMap = [
      { selector: '.js-movie-swiper-wrapper', swiper: movieSwiper },
      { selector: '.js-job-swiper-wrapper', swiper: jobSwiper },
      { selector: '.js-interview-swiper-wrapper', swiper: interviewSwiper },
    ];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const target = swiperObserverMap.find((item) => entry.target.matches(item.selector));
        if (!target) return;
        if (entry.isIntersecting) {
          target.swiper.autoplay.start();
        } else {
          target.swiper.autoplay.stop();
        }
      });
    }, { threshold: 0.1 });

    swiperObserverMap.forEach((item) => {
      const el = document.querySelector(item.selector);
      if (el) observer.observe(el);
    });

    const newsSlider = document.querySelector('.js-news-slider');
    if (newsSlider) {
      const slides = Array.from(newsSlider.querySelectorAll(':scope > a'));
      let currentIndex = 0;

      slides.forEach((slide) => {
        slide.style.transition = 'opacity 0.4s ease';
      });

      const showSlide = (index) => {
        slides.forEach((slide, i) => {
          if (i === index) {
            slide.classList.remove('pointer-events-none', 'opacity-0');
          } else {
            slide.classList.add('pointer-events-none', 'opacity-0');
          }
        });
        currentIndex = index;
      };

      document.querySelector('.js-news-slider-next')?.addEventListener('click', () => {
        showSlide((currentIndex + 1) % slides.length);
      });

      document.querySelector('.js-news-slider-prev')?.addEventListener('click', () => {
        showSlide((currentIndex - 1 + slides.length) % slides.length);
      });
    }

    const aboutBannerZones = document.querySelectorAll('.js-top-about-banner-zone');
    const companySection = document.querySelector('.js-top-company-section');
    const featureSection = document.querySelector('.js-top-feature-section');
    const footer = document.querySelector('.js-footer');
    const aboutBanner = document.querySelector('.js-top-about-banner');
    const spMedia = window.matchMedia('(max-width: 767px)');

    if (aboutBannerZones.length > 0 && aboutBanner) {
      let ticking = false;

      const updateAboutBanner = () => {
        const viewportHeight = window.innerHeight;
        const inAboutZone = Array.from(aboutBannerZones).some((zone) => {
          const rect = zone.getBoundingClientRect();
          return rect.bottom > 0 && rect.top < viewportHeight;
        });

        const featureReached = featureSection
          ? featureSection.getBoundingClientRect().top <= viewportHeight
          : false;
        const footerReached = footer
          ? footer.getBoundingClientRect().top <= viewportHeight
          : false;

        let isVisible = false;
        let isCasual = false;

        if (spMedia.matches) {
          if (footerReached) {
            isVisible = false;
          } else if (featureReached) {
            isVisible = true;
            isCasual = true;
          } else {
            isVisible = inAboutZone;
          }
        } else {
          let companyReached = false;
          if (companySection) {
            const companyTop = companySection.getBoundingClientRect().top;
            companyReached = companyTop <= viewportHeight * 0.88;
          }
          isVisible = inAboutZone && !companyReached;
        }

        aboutBanner.classList.toggle('is-visible', isVisible);
        aboutBanner.classList.toggle('is-casual', isCasual);

        ticking = false;
      };

      const requestAboutBannerUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateAboutBanner);
      };

      updateAboutBanner();
      window.addEventListener('scroll', requestAboutBannerUpdate, { passive: true });
      window.addEventListener('resize', requestAboutBannerUpdate);
    }
  }
}

class CasualMeetingFormCta {
  constructor(selector = 'js-casual-meeting-form-cta') {
    this.selector = selector;
    this.bind();
  }

  bind() {
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element
        ? event.target.closest(`.${this.selector}`)
        : null;

      if (!target) {
        return;
      }

      const eventName = target.getAttribute('data-ga-event') || '';
      const buttonLocation = target.getAttribute('data-button-location') || '';

      if (!eventName) {
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        button_location: buttonLocation,
      });
    });
  }
}

class Common {
  constructor(el,opt){
    this.footerAccordionMedia = window.matchMedia('(max-width: 767px)');
    this.fixedHeaderMedia = window.matchMedia('(min-width: 768px)');
    this.fixedHeaderTicking = false;
    this.isSpDrawerOpen = false;
    this.event();
  }
  initFooterAccordion() {
    const $accordions = $('.js-accordion');
    const isSp = this.footerAccordionMedia.matches;

    $accordions.off('click.footerAccordion');

    if (!isSp) {
      $accordions.removeClass('is-active');
      $accordions.next('.sub').each(function() {
        $(this).stop(true, true).css('display', '');
      });
      
      return;
    }

    $accordions.each(function() {
      const $trigger = $(this);
      const $sub = $trigger.next('.sub');

      if ($trigger.hasClass('is-active')) {
        $sub.show();
      } else {
        $sub.hide();
      }
    });

    $accordions.on('click.footerAccordion', function() {
      const $trigger = $(this);
      $trigger.toggleClass('is-active');
      $trigger.next('.sub').slideToggle(300);
    });
  }
  initFixedHeader() {
    this.$header = $('.js-header').first();
    this.$fixedHeader = $('.js-fixed-header').first();

    if (!this.$header.length || !this.$fixedHeader.length) {
      return;
    }

    this.updateFixedHeader();
  }
  updateFixedHeader() {
    if (!this.$header || !this.$fixedHeader) {
      return;
    }

    if (!this.fixedHeaderMedia.matches) {
      this.$fixedHeader.removeClass('is-show').attr('aria-hidden', 'true').attr('inert', '');
      return;
    }

    const headerBottom = this.$header[0].getBoundingClientRect().bottom;
    const isHeaderHidden = headerBottom <= 0;

    this.$fixedHeader
      .toggleClass('is-show', isHeaderHidden)
      .attr('aria-hidden', isHeaderHidden ? 'false' : 'true');

    if (isHeaderHidden) {
      this.$fixedHeader.removeAttr('inert');
    } else {
      this.$fixedHeader.attr('inert', '');
    }
  }
  requestFixedHeaderUpdate() {
    if (this.fixedHeaderTicking) {
      return;
    }

    this.fixedHeaderTicking = true;
    window.requestAnimationFrame(() => {
      this.updateFixedHeader();
      this.fixedHeaderTicking = false;
    });
  }
  initSpDrawer() {
    this.$spDrawer = $('.js-sp-drawer').first();
    this.$spDrawerOpen = $('.js-sp-menu-open').first();

    if (!this.$spDrawer.length || !this.$spDrawerOpen.length) {
      return;
    }

    this.closeSpDrawer();

    this.$spDrawerOpen.off('click.spDrawer').on('click.spDrawer', () => {
      if (this.isSpDrawerOpen) {
        this.closeSpDrawer(true);
      } else {
        this.openSpDrawer();
      }
    });

    this.$spDrawer.off('click.spDrawerLink').on('click.spDrawerLink', 'a', () => {
      this.closeSpDrawer();
    });

    $(document).off('keydown.spDrawer').on('keydown.spDrawer', (e) => {
      if (e.key === 'Escape' && this.isSpDrawerOpen) {
        this.closeSpDrawer(true);
      }
    });
  }
  openSpDrawer() {
    if (!this.$spDrawer || !this.$spDrawer.length) {
      return;
    }

    this.isSpDrawerOpen = true;
    $('body').addClass('is-sp-drawer-open overflow-hidden');
    this.$spDrawer.addClass('is-open').attr('aria-hidden', 'false').removeAttr('inert');
    this.$spDrawerOpen.attr('aria-expanded', 'true').attr('aria-label', 'メニューを閉じる');
  }
  closeSpDrawer(shouldFocusOpen = false) {
    if (!this.$spDrawer || !this.$spDrawer.length) {
      return;
    }

    this.isSpDrawerOpen = false;
    $('body').removeClass('is-sp-drawer-open overflow-hidden');
    this.$spDrawer.removeClass('is-open').attr('aria-hidden', 'true').attr('inert', '');

    if (this.$spDrawerOpen && this.$spDrawerOpen.length) {
      this.$spDrawerOpen.attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く');
      if (shouldFocusOpen) {
        this.$spDrawerOpen.trigger('focus');
      }
    }
  }
  event(){
    this.initFooterAccordion();
    this.initFixedHeader();
    this.initSpDrawer();

    let footerAccordionResizeTimer;
    $(window).on('resize', () => {
      clearTimeout(footerAccordionResizeTimer);
      footerAccordionResizeTimer = setTimeout(() => {
        this.initFooterAccordion();
        this.updateFixedHeader();
        if (this.fixedHeaderMedia.matches) {
          this.closeSpDrawer();
        }
      }, 150);
    });

    $(window).on('scroll', () => {
      this.requestFixedHeaderUpdate();
    });
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    const isReverse = item.classList.contains('js-inview-each-reverse');
    const eachItems = $(item).find(this.eachItem);
    const eachItemCount = eachItems.length;

    eachItems.each((i,el)=>{
      const index = isReverse ? eachItemCount - 1 - i : i;

      gsap.to($(el), {
        delay: (0.2 * index),
        duration: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}

(() => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let top = new Top('js-top');
  let singleInterview = new SingleInterview('p-single-interview');
  let singleNews = new SingleNews('p-single-news');
  let singleWorks = new SingleWorks(['p-single-works', 'p-single-recruit']);
  let singleRecruit = new SingleRecruit('p-single-recruit');
  let evaluation = new Evaluation('p-evaluation-career');
  let common = new Common('js-common');
  let casualMeetingFormCta = new CasualMeetingFormCta('js-casual-meeting-form-cta');
  $(document).ready(function () {
    new ScrollHint('.js-scrollable',{
      i18n: {
        scrollable: "スクロールできます",
      }
    });
  });
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});
